import { orchestrator } from 'satcheljs';
import { openBoardEditorDialog, closeBoardEditorDialog } from './actions';
import { onOpenBoardEditor, onCloseBoardEditor } from './notificationActions';

orchestrator(openBoardEditorDialog, () => {
    // execute action to notify
    onOpenBoardEditor();
});

orchestrator(closeBoardEditorDialog, () => {
    // execute action to notify
    onCloseBoardEditor();
});
